import React from 'react';
import Footer from 'layouts/Footer';
import Navbar from 'layouts/Navbar';
import About from 'pages/About';
import Blog from 'pages/Blog';
import Contact from 'pages/Contact';
import Home from 'pages/Home';
import NotFound from 'pages/NotFound';
import Projects from 'pages/Projects';
import { Navigate, Route, Routes } from 'react-router-dom';

import { Box } from '@mui/system';

function App() {
  return (
    <Box>
      <Navbar />
      <Routes>
        <Route path='/projects/*' element={<Projects />} />
        <Route path='/about/*' element={<About />} />
        <Route path='/blog/*' element={<Blog />} />
        <Route path='/contact/*' element={<Contact />} />
        <Route path='/404' element={<NotFound />} />
        <Route path='/' element={<Home />} />
        <Route path='*' element={<Navigate replace to='/404' />} />
      </Routes>
      <Footer />
    </Box>
  );
}

export default App;
